module.exports = __webpack_public_path__ + "img/level-1-active.5e757a4a.svg";